import store from '../store';
import api from '../api/api';
import storeJs from 'storejs';
import md5 from 'js-md5';
import router from "../router";
import Config from "../api/api.config.js";
//let OSS = require('ali-oss')
//import {client, getFileNameUUID} from "../utils/oss";
import AWS from 'aws-sdk';
export default{
    userInfo:{

    },
    async auth() {
        const token = store.state.token;
        if (token !== null && token !== undefined && token !== ''){
            const {ret,data} = await api.authorization();
            if (ret !== 1000){
                storeJs.remove('token');
                storeJs.remove('userInfo');
                store.state.token = '';
                await router.push({name: 'login'});
            }else {
                storeJs.set('userInfo',data.user_info);
                this.userInfo=data.user_info;
            }
        }
    },
    async getIdentity() {
        const identity = store.state.identity;
        if (identity === null || identity === undefined || identity === ''){
            const {ret,data} = await api.getIdentity();
            if (ret === 1000){
                store.state.identity = data.identity;
                storeJs.set('identity',data.identity);
            }
        }
    },
    async loginOut() {
        const {ret} = await api.logout();
        if (ret === 1000){
            storeJs.remove('token');
            storeJs.remove('userInfo');
            store.state.token = '';
            await router.push('/login');
        }
    },
    isUrl(url) {
        if(url.match(/^mp:\/\//i)){
            return true;
        }else{
            let strRegex =/^([hH][tT][tT][pP]|[fF][tT][pP])([sS]?):\/\/((\w{1,50})?\.?)(\w{1,50}\-\w{1,50}\.?|\w{1,50}\.?)(\w{1,50}\.)?(\w{2,10})\S{2,}$/;
            let re = new RegExp(strRegex);
            return re.test(url);
        }

    },
    captchaSign(phone,code,time) {
        const key = "9234b70dff22042e884e4652f6cd2b7c";
        return md5(key+phone+code+time);
    },
    urlSign(url) {
        const key = "70e719d29a2fe757edde13127f210106";
        return md5(key+url);
    },
    // //上传图片
    // Upload(file,callback) {//alert('upload 01')
    //     let temporary = file.file.name.lastIndexOf(".");
    //     let fileNameLength = file.file.name.length;
    //     let fileFormat = file.file.name.substring(
    //         temporary + 1,
    //         fileNameLength
    //     );
    //     let fileName = getFileNameUUID() + "." + fileFormat;
    //     var myDate = new Date();
    //     var file_path='dwz/'+myDate.getFullYear()+myDate.getMonth()+'/'+myDate.getDate()+'/'+fileName;
    //     //alert(file_path);
    //     client().multipartUpload(file_path, file.file, {
    //             progress: function(p) {
    //                 //p进度条的值
    //                 console.log(p);
    //                 //that.showProgress = true;
    //                 //that.progress = Math.floor(p * 100);
    //             }
    //         })
    //         .then(async () => {
    //             //上传成功返回值，可针对项目需求写其他逻辑
    //             //console.log(result);
    //             var img='https://file-social.ttdwz.cc/'+file_path;
    //
    //             callback(img);
    //
    //         })
    //         .catch(err => {
    //             console.log("err:", err);
    //             if(errorback) errorback(img);
    //         });
    // },
     getRandomString(length = 10) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    },
    async Upload(file2,callback) {
        const file = file2.file;
        const fileExt = file.name.split('.').pop();
        const contentType = file.type;

        console.log(Config.baseUrl);

        // 向后端请求预签名URL
        const res = await fetch(Config.baseUrl+'/common/getAwsSignedUrl', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                file_ext: fileExt,
                content_type: contentType
            })
        });
        const { upload_url, file_url } = await res.json();

        // 使用预签名URL上传文件
        const result = await fetch(upload_url, {
            method: 'PUT',
            headers: {
                'Content-Type': contentType
            },
            body: file
        });

        if (result.ok) {
            console.log('文件上传成功:', file_url);
            callback(file_url);
        } else {
            console.error('上传失败');
            callback(null);
        }
    },


    get_day_folder(){
        var d = new Date;
        var year = d.getFullYear();
        var month = (d.getMonth() + 1) >=10? (d.getMonth() + 1) : "0" + (d.getMonth() + 1);
        var date = d.getDate() >=10 ? d.getDate() : "0" + d.getDate();
        var tempDate = year + "/" + month + "/" + date;
        console.log(tempDate)  //输出格式：xxxx-xx-xx
        return tempDate;

    }

}
